<template>
  <div>
    <div class="center title-mailboxes" v-if="this.$route.params.type == 'mailboxes'">
      <!-- All -->
      <div class="float-left header-icon left-wrapper extra-margin">
        <div class=" home-split first">
          <span>
            Mailboxes
          </span>
        </div>
      </div>
    </div>

    <div class="email-center-options" v-else>
      <div class="home-split first">

        <div v-if="this.$route.params.type == 'unread' || this.$route.params.type == 'inbox'">
          <a href="javascript:void(0)" @click.prevent="clearEditStateAndRedirect('unread')"
             :class="{ plain: this.$route.params.type == 'unread' }">
            Unread
          </a>

          <span class="plain">|</span>

          <a href="javascript:void(0)" @click.prevent="clearEditStateAndRedirect('inbox')"
             :class="{ plain: this.$route.params.type == 'inbox' }">
            Inbox
          </a>
        </div>

        <div v-else>
          <span class="plain email-secondary-title">
            <span v-if="this.$route.params.type == 'custom'">
            {{ this.selectedCustomFolderName }}
            </span>
            <span v-else>
            {{ capitalizeFirstLetter(this.$route.params.type) }}
            </span>
          </span>
        </div>

      </div>
    </div>

    <div class="center" v-if="this.$route.params.type != 'mailboxes'">
      <!-- All -->
      <div
        class="float-left header-icon left-wrapper extra-margin back-to-mailboxes"
        v-if="backtoemailfolders"
      >
        <div class="home-split first">
          <span v-if="isEditCicked" @click="selectAllClick" class="select-all-emails">Select All</span>
          <router-link to="/emails/mailboxes" v-else>
            <object
              class="search-icon icon-back"
              :data="backSvg"
              type="image/svg+xml"
            ></object>
            Mailboxes
          </router-link>
        </div>
      </div>

      <div class="float-right header-icon right-wrapper extra-margin">
        <div class=" home-split first email-edit">
          <span v-if="!isEditCicked" @click="editButton">Edit</span>
          <span v-if="isEditCicked" @click="cancelEdit">Cancel</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "MailHeaderList",
  data() {
    return {
      backSvg: require("../../../assets/svg/back.svg")
    };
  },
  props: {
    isEditCicked: Boolean,
    backtoemailfolders: Boolean
  },
  computed: {
    ...mapGetters("portalemail", {
      selectedCustomFolderName: "getSelectedCustomFolderName"
    })
  },
  methods: {
    clearEditStateAndRedirect(path) {
      if(this.$route.params.type !== path) {
        this.$parent.$parent.clearEditState();
        this.$router.push("/emails/" + path);
      }
    },
    capitalizeFirstLetter(string) {
      if('draft' === string) {
        string = 'drafts';
      }

      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    editButton() {
      this.$parent.$parent.isEditCicked = true;
      // this.isEditCicked = !this.isEditCicked;
    },
    cancelEdit() {
      this.$parent.$parent.isEditCicked = false;
      this.$parent.$parent.selectAll = false;
      // this.isEditCicked = !this.isEditCicked;
    },
    selectAllClick() {
      this.$parent.$parent.selectAll = !this.$parent.$parent.selectAll;
    }
  }
};
</script>

<style scoped>
.plain {
  font-weight: 300;
  font-size: 20px;
  color: #000;
}
div.center {
  display: flex !important;
  margin: 0 0 10px 0 !important;
  justify-content: space-between !important;
  flex-wrap: no-wrap;
}
.center.title-mailboxes{
  justify-content: center!important;
  width:100%;
  margin:0!important;

}
.center.title-mailboxes span{
  position:relative;
  top:-8px;
}
span.select-all-emails{
  color: #d26d13;
  cursor: pointer;
  padding-left:10px;
  position:relative;
  top:8px;
}
.email-center-options{
  width:100%;
  margin:0 auto;
  text-align:center;
  max-height: 25px;
}
.email-center-options .home-split{
  width:100%;
  margin:0 auto;
  text-align:center;

}
.email-center-options .home-split.first > div{
  width:98%;
  display:block;
  margin:0 auto;
  text-align:center;
  display:flex;
  justify-content:center;
    position:relative;
  top:-10px;
}
.email-center-options span.plain{
  padding:0 5px;
}
.email-center-options a{
  font-size:16px!important;
  line-height: 24px;
}

.container-radio {
  padding-right: 0px !important;
  padding-left: 18px;
}
.back-to-mailboxes{
  margin-top:-5px;
}
.back-to-mailboxes .icon-back{
  top:4px;
}
.email-edit{
  color:#d26d13;
  position:relative;
  top:4px;
  padding-right:10px;
  min-width:90px;
  text-align:right;
  cursor:pointer;
  }
  .email-secondary-title{
    font-size:16px;
    text-align:center;
  }
@media screen and (max-width:480px){
  .home-split.first{
    margin-left:unset!important;
  }


}
</style>
